import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

type MessageKey =
  | 'noItemsBanner'
  | 'noFolderAssoicatedWithUploadBanner'
  | 'noFolderAssociatedWithUploadMessage'
  | 'noOptionsMessage'
  | 'duplicateOptionsError'
  | 'defaultErrorBanner'
  | 'defaultErrorInline'
  | 'formBuilderLogicErrorBanner'
  | 'formBuilderLogicErrorPanel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  noItemsBanner: {
    id: 'boxForms.builderErrors.noItemsBanner',
    description: 'Banner Error Message when there are no fields in the form',
    defaultMessage: 'Add at least one form field to save or share this form.',
  },
  noFolderAssoicatedWithUploadBanner: {
    id: 'boxForms.builderErrors.noFolderAssoicatedWithUploadBanner',
    description:
      'Banner error message when there is no folder associated with the upload',
    defaultMessage:
      'Failed to save form because one or more file upload fields requires a destination folder. Please choose a folder to proceed.',
  },
  noFolderAssociatedWithUploadMessage: {
    id: 'boxForms.builderErrors.noFolderAssociatedWithUploadMessage',
    description:
      'Error message within upload field and upload settings panel when there is no folder associated with the upload',
    defaultMessage: 'Please select a destination folder',
  },
  noOptionsMessage: {
    id: 'boxForms.builderErrors.noOptionsMessage',
    description:
      'Error message when no options are provided for the dropdown / radio / checkbox field',
    defaultMessage: 'Please provide at least one option value',
  },
  duplicateOptionsError: {
    id: 'boxForms.builderErrors.duplicateOptionError',
    description:
      'Error message for checkbox / radio / dropdown field options duplicates',
    defaultMessage: 'Option values include duplicates',
  },
  defaultErrorBanner: {
    id: 'boxForms.builderErrors.multipleErrorsBanner',
    description:
      'Default banner error message for miscellaneous or multiple error(s)',
    defaultMessage: 'One or more fields are invalid or incomplete.',
  },
  defaultErrorInline: {
    id: 'boxForms.builderErrors.defaultErrorInline',
    description:
      'Default inline field element error message for miscellaneous error(s)',
    defaultMessage: 'This field is invalid or incomplete.',
  },
  formBuilderLogicErrorBanner: {
    id: 'boxForms.builderErrors.formBuilderLogicErrorBanner',
    description:
      'Banner Error Message displayed when the user attempts to save a form with invalid logic',
    defaultMessage:
      'Failed to save form because of an issue with one or more Form Logics',
  },
  formBuilderLogicErrorPanel: {
    id: 'boxForms.builderErrors.formBuilderLogicErrorPanel',
    description:
      'Error Message displayed in Logic Panel in right side bar when the user attempts to save a form with invalid logic',
    defaultMessage: 'Some logic contain rules with deleted fields or values',
  },
});

export default messages;
